export const API_FACEBOOK_ROUTES = Object.freeze({
  BUSINESS_ASSETS: '/facebook/business-assets',
  BUSINESS_ASSET: '/facebook/business-assets/:id',
  CAMPAIGNS: '/facebook/campaign',
  CAMPAIGNS_REFRESH: '/facebook/campaign/refresh',
  ADSET_AD_COUNT: '/facebook/adset/ad-count',
  INSTAGRAM_ACCOUNTS: '/facebook/business-assets/page/:facebookId/instagram-accounts',
});
